export default "__VITE_ASSET__BcYjpSYk__"